import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, useParams, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import { InputGroup, InputGroupText, Tooltip } from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";

const UserCodePromo = (props) => {
  const url = process.env.REACT_APP_API_URL;
  //Début code pour get le client sélectionné
  const UserId = useParams("id");
  const [loading, setLoading] = useState(true);
  const [filleuls, setFilleuls] = useState([]);

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  const history = useHistory();
  const [formData1, setFormData1] = useState({});
  const dispatch = useDispatch();
  const token = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).accessToken
    : null;

  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);

  function handleClick() {
    forceUpdate();
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await axiosInstance.get(`/clientdetail/?id=${UserId.id}`);
        setFilleuls(data.data.data);
        // console.log("data: ", data.data.data);
      } catch (err) {
        console.error(
          `Erreur de récupération des données du client ${UserId.id}: `,
          err
        );
      }
    };
    fetchData();
  }, [UserId, url]);

  useEffect(() => {
    // console.log("parainages: ", parainages);
    if (!isEmpty(filleuls)) {
      setFilleuls(filleuls);
    }
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [filleuls]);

  const [isEdit, setIsEdit] = useState(false);
  const [driverSelected, setDriverSelected] = useState(null);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [parainage, setParainage] = useState([]);

  //delete Conatct
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalMotif, setModalMotif] = useState(false);

  const handleClickViewMotif = (etat, motifs) => {
    if (etat === "Desactiver" && motifs != null) {
      alert(motifs);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setParainage(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  // Add Data
  const handleParainageClicks = () => {
    setParainage("");
    setIsEdit(false);
    toggle();
  };

  const dateFormat = () => {
    var d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    return d.getDate() + " " + months[d.getMonth()] + ", " + d.getFullYear();
  };

  const timeFormat = () => {
    let d = new Date();
    let minutes =
      d.getMinutes().toString().length === 1
        ? "0" + d.getMinutes()
        : d.getMinutes();
    let hours = d.getHours().toString() % 12 || 12;
    hours = hours <= 9 ? (hours = "0" + hours) : hours;
    let ampm = d.getHours() >= 12 ? "PM" : "AM";
    return hours + ":" + minutes + ampm;
  };

  // Update Data
  const handleParainageClick = useCallback(
    (arg) => {
      const parainage = arg;

      setParainage({
        id: parainage.id,
        parainage: parainage.parainage,
        user_id: parainage.user_id,
        type_reduction: parainage.type_reduction,
        pourcentage: parainage.pourcentage,
        delais: parainage.delais,
        nbr_max: parainage.nbr_max,
        statut: parainage.statut,
      });

      toggle();
    },
    [toggle]
  );

  // Column
  const columns = useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
      //   Cell: ( cellProps ) =>
      //   {
      //     return <input type="checkbox" name="id" className="parainageCheckBox" value={ cellProps.row.original.id } />;
      //   },
      //   id: '#',
      // },

      {
        Header: props.t("Créateur"),
        accessor: "last_name",
        filterable: false,
        Cell: (createur) => (
          <>
            {createur.row.original.last_name} {createur.row.original.first_name}
          </>
        ),
      },
      {
        Header: props.t("Code de Parainage"),
        accessor: "code_parrainage",
        filterable: false,
        Cell: (cell) => (
          <>
            <b style={{ color: "#014c94" }}>
              {cell.row.original.code_parrainage}
            </b>
          </>
        ),
      },
      {
        Header: props.t("Parainés"),
        accessor: "parainee",
        filterable: false,
        Cell: (cell) => (
          <>
            <b style={{ color: "#014c94" }}>
              {cell.row.original.parainee || 0}
            </b>
          </>
        ),
      },
      {
        Header: props.t("Action"),
        Cell: (cellProps) => {
          const parainageData = cellProps.row.original;
          const parainageDataId = cellProps.row.original.id;
          const [info, setInfo] = useState([]);
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  // to={`/parainageDetail/${parainageData.id}`}
                  to={"#"}
                  className="btn btn-sm btn-success d-inline-block"
                  onClick={() => {
                    const parainageData = cellProps.row.original;
                  }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleParainageClick, props]
    // [setInfo, handleParainageClick, toggle, props, handlerefuse, handleaccept]
  );

  // SideBar Parainage Deatail

  document.title = props.t("Parainages | Takci");
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={props.t("Liste des Filleuls")}
            pageTitle="Parainages"
            pageTitleLink="/parainage"
          />
          
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      {filleuls.length > 0 && (
                        <button
                          disabled={filleuls.length < 0}
                          type="button"
                          className="btn"
                          style={{ color: "#eac22f" }}
                          onClick={() => setIsExportCSV(true)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                          {props.t("Export")}
                        </button>
                      )}
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={12}>
              <Card id="parainageList">
                <CardBody className="pt-0">
                  <div>
                    {!loading ? (
                      filleuls.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={isExportCSV}
                            onCloseClick={() => setIsExportCSV(false)}
                            data={filleuls.length > 0 ? filleuls : []}
                          />

                          <TableContainer
                            columns={columns}
                            data={filleuls.length > 0 ? filleuls : []}
                            isGlobalFilter={true}
                            isAddUserList={false}
                            customPageSize={8}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleParainageClick={handleParainageClicks}
                          />
                        </>
                      ) : (
                        <h2 className="text-center my-3">
                          Aucune information disponible pour ce code de
                          parainage
                        </h2>
                      )
                    ) : (
                      <div className="text-center my-3">
                        {/* <Spinner size="sm" className=''
                            style={ { color: '#014c94' } }
                          /> */}
                        <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
                      </div>
                    )}
                  </div>

                  <ToastContainer closeButton={false} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

UserCodePromo.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(UserCodePromo));
